// extracted by mini-css-extract-plugin
export default {"container":"footer-rhoneacademy_container__2dXJs","content":"footer-rhoneacademy_content__3BMYR","logo":"footer-rhoneacademy_logo__3HlWB"};